<template>
  <div id="settings">
    <van-nav-bar
        title="设置"
        right-text="刷新"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
    <div class="content">
      <!-- 版本更新 -->
      <van-cell
          title="版本更新"
          is-link
          icon="upgrade"
          @click="checkVersion"
      />

      <!-- 退出登录 -->
      <van-cell
          title="退出登录"
          is-link
          icon="close"
          @click="logout"
      />
    </div>
  </div>
</template>
<script>
import {Toast} from "vant";

export default {
  data () {
    return {

    }
  },
  methods: {
    loading () {
    },
    checkVersion() {
      // 在这里处理版本更新的逻辑
      // 可以检查服务器上的新版本，并提示用户更新
    },
    logout() {
      // 在这里处理退出登录的逻辑
      // 可以清除用户登录信息并导航到登录页面
    },
    onClickLeft () {
      this.$router.go(-1);
    },
    onClickRight () {
      this.loading()
      Toast('已刷新');
    },
  },
  mounted () {
    this.loading()
  }
}
</script>
<style scoped>
/* 样式可以根据需要进行自定义 */
.content {
  padding: 16px;
}
/* 为版本更新和退出登录添加图标的样式 */
.content .van-cell {
  margin-bottom: 16px;
  background-color: #f8f8f8;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.content .van-cell__right-icon i {
  font-size: 18px;
  color: #999;
}
/* 按下效果 */
.content .van-cell:active {
  background-color: #e0e0e0; /* 修改背景颜色 */
}
</style>